import React, { useRef, useState } from "react";
import "./Select.css";
import { Container } from "../../layout";
import Text from "../typography/Text";

function Select({ name, options, onChange, value, label }) {
  const [selected, setselected] = useState("");
  const inputRef = useRef(null);

  // Fonction pour activer l'input lors d'un clic sur le conteneur
  const handleFocus = () => {
    inputRef.current?.focus();
  };
  return (
    <Container className="Input">
      {/* Affiche le label si fourni */}
      {label && (
        <Text size="sm" className="text-sm" onClick={handleFocus}>
          {label}
        </Text>
      )}
      <select
        ref={inputRef}
        className="Select"
        name={name}
        id=""
        onChange={(e) => [onChange(e), setselected(e.target.value)]}
        value={value || selected}
      >
        {options &&
          options.map((opt, index) => (
            <option key={index} value={opt.value}>
              {opt.name}
            </option>
          ))}
      </select>
    </Container>
  );
}

export default Select;
